<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Marcas / Modelos</li>
						</ol>
						<div class="title">
							<h1>Marcas / Modelos</h1>
						</div>
						<div class="cta">
							<button class="btn btn-sm btn-outline-secondary" @click="openModal(null)">Crear marca</button>
						</div>
					</div>

					<table class="table table-clickeable">
						<tr class="table-head">
							<td></td>
							<td>Marca</td>
							<td>Modelos</td>
						</tr>
						
						<tr v-for="item of list" :key="item.id" @click="openModal(item.id)">
							<td class="text-center">
								<img v-if="item.logo" :src="API_URL+item.logo.urlThumb"  style="height:24px;">
							</td>
							<td>
									{{item.title}}
							</td>
							<td>
								<span v-for="model in item.models" :key="model.title">
									{{model.title}},
								</span>
							</td>
						</tr>
						
					</table>

					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado marcas</div>
		
				</div>
			</div>
		</div>
	</div>
	<BrandModal ref="brandModal" @updated="load()"></BrandModal>

</div>
</template>

<script>
import gql from 'graphql-tag'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

import BrandModal from '@/views/brands/BrandModal'

export default {
	name: 'brands',
	components:{
		Navbar,
		Loader,
		BrandModal
	},
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			list:[],
			loading: true,
		}
	},
	beforeMount(){
		this.load();
	},
	methods:{
		load(){
			this.$apollo.query({
				query: gql`query {
					car_brands {
						id
						title
						models{
							title
						},
						logo{
							urlThumb
						}
					}
				}`,
				variables: {
				},
			})
			.then((data) => {
				this.list = data.data.car_brands;
				this.loading = false
			});
		},
		openModal(id){
			this.$refs.brandModal.open(id)
		}

	}
}


</script>

<style>

</style>
